export var CORE_DEEPLINK_CONFIG = {
    ContactsPicker: 'contacts/choose',
    Conversation: 'conversation/:ID',
    EditLessonsLearned: 'lessons-learned/edit',
    FinishPatientRegistration: 'finish-patient-registration',
    LocalAuthenticationPrompt: 'local-authentication-prompt',
    Login: 'auth/login',
    MediaPicker: 'media/choose',
    QuizSet: 'quiz-set/:slug',
    RequestResetPassword: 'auth/requestreset',
    ResetPassword: 'auth/reset',
    SignUp: 'auth/signup',
    TermsAndPrivacy: 'terms-and-privacy',
    TestArtifactResult: 'TestArtifactResult',
    AccountSettings: 'account'
};
